// extracted by mini-css-extract-plugin
export default {"lg":"CloseButton__lg__CMV4C"};